<template>
  <div v-if="showSelector" class="oa-location-selector">
    <div class="oa-location-selector-row">
      <label class="oa-location-label">{{ label }}</label>
      <button
        v-if="showCopyButton"
        class="oa-btn oa-btn-secondary oa-btn-sm"
        @click="$emit('copy-settings')"
      >
        <i class="fa fa-copy"></i> Copy from another location
      </button>
    </div>

    <div class="oa-location-status-row">
      <div
        v-for="loc in locations"
        :key="loc.siteId"
        class="oa-location-status-item"
        :class="{
          'active': loc.siteId === value,
          'configured': getStatus(loc.siteId).configured,
          'needs-setup': !getStatus(loc.siteId).configured
        }"
        @click="$emit('input', loc.siteId)"
      >
        <i :class="loc.siteId === value ? 'fa fa-circle' : (getStatus(loc.siteId).configured ? 'fa fa-check-circle' : 'fa fa-exclamation-circle')"></i>
        <span class="oa-location-status-name">{{ loc.name }}</span>
        <span v-if="showCount" class="oa-location-status-count">
          ({{ getStatus(loc.siteId).appointmentTypeCount || 0 }} types)
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'LocationSelector',
  props: {
    value: { type: String, default: '' }, // v-model for selected siteId
    locations: { type: Array, default: () => [] }, // paidLocations array
    locationStatus: { type: Object, default: () => ({}) }, // locationStatus from store
    label: { type: String, default: 'Configuring for:' },
    showCopyButton: { type: Boolean, default: true },
    showCount: { type: Boolean, default: false } // Show appointment type count
  },

  computed: {
    showSelector() {
      return this.locations && this.locations.length > 1;
    }
  },

  methods: {
    getStatus(siteId) {
      return this.locationStatus[siteId] || { configured: false, appointmentTypeCount: 0 };
    }
  }
};
</script>
